// @ts-nocheck
// Adapter widget for the dashboard grid: reads the shared date-range +
// call-summary state from DashboardDataContext and renders the existing
// prop-driven DashboardCallsCharts unchanged.
import DashboardCallsCharts from './DashboardCallsCharts';
import { useDashboardData } from '../DashboardDataContext';

export default function CallsChartsWidget() {
  const d = useDashboardData();
  return (
    <DashboardCallsCharts
      barAgentsData={d.barAgentsData}
      doughnutData1={d.doughnutData1}
      barIncomingData={d.barIncomingData}
      incomingData={d.incomingData}
      isIncomingDataEmpty={d.isIncomingDataEmpty}
      barOutgoingData={d.barOutgoingData}
      outgoingDataDoughnut={d.outgoingDataDoughnut}
      isOutgoingDataEmpty={d.isOutgoingDataEmpty}
      startDate={d.startDate}
      endDate={d.endDate}
      handleDashboardStartDateChange={d.handleDashboardStartDateChange}
      handleDashboardEndDateChange={d.handleDashboardEndDateChange}
      dashboardStartCalendarMinDate={d.dashboardStartCalendarMinDate}
      dashboardStartCalendarMaxDate={d.dashboardStartCalendarMaxDate}
      dashboardEndCalendarMinDate={d.dashboardEndCalendarMinDate}
      dashboardEndCalendarMaxDate={d.dashboardEndCalendarMaxDate}
      handleFilter={d.handleFilter}
      onRefreshCalls={d.refreshIncomingOutgoing}
      answeredUnansweredSummary={d.answeredUnansweredSummary}
      answeredUnansweredSummaryLoading={d.answeredUnansweredSummaryLoading}
    />
  );
}
